var map = {
	"./bishop-bw-dark.png": 4367,
	"./bishop-bw-light.png": 2718,
	"./bishop-default-dark.png": 7659,
	"./bishop-default-light.png": 3672,
	"./king-bw-dark.png": 3726,
	"./king-bw-light.png": 2016,
	"./king-default-dark.png": 61,
	"./king-default-light.png": 2095,
	"./knight-bw-dark.png": 8847,
	"./knight-bw-light.png": 3580,
	"./knight-default-dark.png": 6411,
	"./knight-default-light.png": 6784,
	"./pawn-bw-dark.png": 6865,
	"./pawn-bw-light.png": 3447,
	"./pawn-default-dark.png": 8099,
	"./pawn-default-light.png": 1943,
	"./queen-bw-dark.png": 2905,
	"./queen-bw-light.png": 9049,
	"./queen-default-dark.png": 874,
	"./queen-default-light.png": 7783,
	"./rook-bw-dark.png": 2988,
	"./rook-bw-light.png": 5787,
	"./rook-default-dark.png": 7357,
	"./rook-default-light.png": 7530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;